module.exports = __webpack_public_path__ + "static/media/gamification_1_zh_HK.cb4bc188.png";